import { DELTA_OPTION_SELECT } from '../constants';

export interface DeltaActionSelect {
    type: 'DELTA_OPTION_SELECT';
}
export type DeltaActions = DeltaActionSelect;
export type DeltaSelect = (option: string, id: string) => void;

export const deltaOptionSelect = (option: string, id: string) => {
    return function (dispatch: Function) {
        dispatch({
            type: DELTA_OPTION_SELECT,
            payload: {
                option,
                id
            }
        });
    };
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/store/action/deltaActions.ts